// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2b-0";
export var spinnerContainer = "_2b-1";